// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "codesandbox/v1/codesandbox.proto" (package "codesandbox.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Internal RPCs for the Control tab's code sandbox.
//
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message codesandbox.v1.RunProgramRequest
 */
export interface RunProgramRequest {
    /**
     * Caller-generated identifier, used to stop the run. Only ever resolved
     * alongside the caller's own identity, so a guessed value reaches nothing.
     *
     * @generated from protobuf field: string run_id = 1;
     */
    runId: string;
    /**
     * The part the program runs against; the caller must have control access.
     *
     * @generated from protobuf field: string part_id = 2;
     */
    partId: string;
    /**
     * @generated from protobuf field: codesandbox.v1.Language language = 3;
     */
    language: Language;
    /**
     * The whole program, as a single file.
     *
     * @generated from protobuf field: string source = 4;
     */
    source: string;
}
/**
 * Sent once the program is launched, marking "starting" -> "running".
 *
 * @generated from protobuf message codesandbox.v1.ProgramStarted
 */
export interface ProgramStarted {
}
/**
 * A chunk of program output. Not guaranteed to be line-aligned.
 *
 * @generated from protobuf message codesandbox.v1.ProgramOutput
 */
export interface ProgramOutput {
    /**
     * @generated from protobuf field: codesandbox.v1.OutputStream stream = 1;
     */
    stream: OutputStream;
    /**
     * @generated from protobuf field: string text = 2;
     */
    text: string;
}
/**
 * Sent once the program has exited; the sandbox is terminated right after.
 *
 * @generated from protobuf message codesandbox.v1.ProgramFinished
 */
export interface ProgramFinished {
    /**
     * @generated from protobuf field: int32 exit_code = 1;
     */
    exitCode: number;
}
/**
 * @generated from protobuf message codesandbox.v1.RunProgramResponse
 */
export interface RunProgramResponse {
    /**
     * @generated from protobuf oneof: event
     */
    event: {
        oneofKind: "started";
        /**
         * @generated from protobuf field: codesandbox.v1.ProgramStarted started = 1;
         */
        started: ProgramStarted;
    } | {
        oneofKind: "output";
        /**
         * @generated from protobuf field: codesandbox.v1.ProgramOutput output = 2;
         */
        output: ProgramOutput;
    } | {
        oneofKind: "finished";
        /**
         * @generated from protobuf field: codesandbox.v1.ProgramFinished finished = 3;
         */
        finished: ProgramFinished;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message codesandbox.v1.StopProgramRequest
 */
export interface StopProgramRequest {
    /**
     * @generated from protobuf field: string run_id = 1;
     */
    runId: string;
    /**
     * The part the run is bound to. A wrong value matches nothing, so it is
     * reported as absent.
     *
     * @generated from protobuf field: string part_id = 2;
     */
    partId: string;
}
/**
 * @generated from protobuf message codesandbox.v1.StopProgramResponse
 */
export interface StopProgramResponse {
}
/**
 * @generated from protobuf message codesandbox.v1.CheckHealthRequest
 */
export interface CheckHealthRequest {
}
/**
 * @generated from protobuf message codesandbox.v1.RecordRunRequest
 */
export interface RecordRunRequest {
    /**
     * The part the run is bound to; the caller must have control access to it.
     *
     * @generated from protobuf field: string part_id = 1;
     */
    partId: string;
    /**
     * @generated from protobuf field: codesandbox.v1.Language language = 2;
     */
    language: Language;
}
/**
 * @generated from protobuf message codesandbox.v1.RecordRunResponse
 */
export interface RecordRunResponse {
}
/**
 * @generated from protobuf message codesandbox.v1.CheckHealthResponse
 */
export interface CheckHealthResponse {
    /**
     * True when a run attempted now would reach the provider. False is a
     * provider that is configured but unreachable, or refusing our credentials.
     *
     * @generated from protobuf field: bool healthy = 1;
     */
    healthy: boolean;
    /**
     * Why it is not healthy, for a human reading a log or a tooltip. Never
     * carries credentials or provider identifiers.
     *
     * @generated from protobuf field: string reason = 2;
     */
    reason: string;
}
/**
 * Language the program is written in, which selects the sandbox image and the
 * command used to execute it.
 *
 * @generated from protobuf enum codesandbox.v1.Language
 */
export enum Language {
    /**
     * @generated from protobuf enum value: LANGUAGE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: LANGUAGE_PYTHON = 1;
     */
    PYTHON = 1,
    /**
     * @generated from protobuf enum value: LANGUAGE_GO = 2;
     */
    GO = 2,
    /**
     * Runs in the browser, so it selects no image and RunProgram refuses it.
     * Present because RecordRun counts it.
     *
     * @generated from protobuf enum value: LANGUAGE_TYPESCRIPT = 3;
     */
    TYPESCRIPT = 3
}
/**
 * Which of the program's output streams a chunk came from.
 *
 * @generated from protobuf enum codesandbox.v1.OutputStream
 */
export enum OutputStream {
    /**
     * @generated from protobuf enum value: OUTPUT_STREAM_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: OUTPUT_STREAM_STDOUT = 1;
     */
    STDOUT = 1,
    /**
     * @generated from protobuf enum value: OUTPUT_STREAM_STDERR = 2;
     */
    STDERR = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class RunProgramRequest$Type extends MessageType<RunProgramRequest> {
    constructor() {
        super("codesandbox.v1.RunProgramRequest", [
            { no: 1, name: "run_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "language", kind: "enum", T: () => ["codesandbox.v1.Language", Language, "LANGUAGE_"] },
            { no: 4, name: "source", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message codesandbox.v1.RunProgramRequest
 */
export const RunProgramRequest = new RunProgramRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProgramStarted$Type extends MessageType<ProgramStarted> {
    constructor() {
        super("codesandbox.v1.ProgramStarted", []);
    }
}
/**
 * @generated MessageType for protobuf message codesandbox.v1.ProgramStarted
 */
export const ProgramStarted = new ProgramStarted$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProgramOutput$Type extends MessageType<ProgramOutput> {
    constructor() {
        super("codesandbox.v1.ProgramOutput", [
            { no: 1, name: "stream", kind: "enum", T: () => ["codesandbox.v1.OutputStream", OutputStream, "OUTPUT_STREAM_"] },
            { no: 2, name: "text", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message codesandbox.v1.ProgramOutput
 */
export const ProgramOutput = new ProgramOutput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProgramFinished$Type extends MessageType<ProgramFinished> {
    constructor() {
        super("codesandbox.v1.ProgramFinished", [
            { no: 1, name: "exit_code", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message codesandbox.v1.ProgramFinished
 */
export const ProgramFinished = new ProgramFinished$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RunProgramResponse$Type extends MessageType<RunProgramResponse> {
    constructor() {
        super("codesandbox.v1.RunProgramResponse", [
            { no: 1, name: "started", kind: "message", oneof: "event", T: () => ProgramStarted },
            { no: 2, name: "output", kind: "message", oneof: "event", T: () => ProgramOutput },
            { no: 3, name: "finished", kind: "message", oneof: "event", T: () => ProgramFinished }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message codesandbox.v1.RunProgramResponse
 */
export const RunProgramResponse = new RunProgramResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StopProgramRequest$Type extends MessageType<StopProgramRequest> {
    constructor() {
        super("codesandbox.v1.StopProgramRequest", [
            { no: 1, name: "run_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message codesandbox.v1.StopProgramRequest
 */
export const StopProgramRequest = new StopProgramRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StopProgramResponse$Type extends MessageType<StopProgramResponse> {
    constructor() {
        super("codesandbox.v1.StopProgramResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message codesandbox.v1.StopProgramResponse
 */
export const StopProgramResponse = new StopProgramResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckHealthRequest$Type extends MessageType<CheckHealthRequest> {
    constructor() {
        super("codesandbox.v1.CheckHealthRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message codesandbox.v1.CheckHealthRequest
 */
export const CheckHealthRequest = new CheckHealthRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RecordRunRequest$Type extends MessageType<RecordRunRequest> {
    constructor() {
        super("codesandbox.v1.RecordRunRequest", [
            { no: 1, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "language", kind: "enum", T: () => ["codesandbox.v1.Language", Language, "LANGUAGE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message codesandbox.v1.RecordRunRequest
 */
export const RecordRunRequest = new RecordRunRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RecordRunResponse$Type extends MessageType<RecordRunResponse> {
    constructor() {
        super("codesandbox.v1.RecordRunResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message codesandbox.v1.RecordRunResponse
 */
export const RecordRunResponse = new RecordRunResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckHealthResponse$Type extends MessageType<CheckHealthResponse> {
    constructor() {
        super("codesandbox.v1.CheckHealthResponse", [
            { no: 1, name: "healthy", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message codesandbox.v1.CheckHealthResponse
 */
export const CheckHealthResponse = new CheckHealthResponse$Type();
/**
 * @generated ServiceType for protobuf service codesandbox.v1.CodeSandboxService
 */
export const CodeSandboxService = new ServiceType("codesandbox.v1.CodeSandboxService", [
    { name: "RunProgram", serverStreaming: true, options: {}, I: RunProgramRequest, O: RunProgramResponse },
    { name: "StopProgram", options: {}, I: StopProgramRequest, O: StopProgramResponse },
    { name: "CheckHealth", options: {}, I: CheckHealthRequest, O: CheckHealthResponse },
    { name: "RecordRun", options: {}, I: RecordRunRequest, O: RecordRunResponse }
]);
